import React, { useState } from "react";
import ExecutiveMail from "./ExecutiveMail";
import PolicyBuilder from "../puzzles/PolicyBuilder";

export default function ExecutiveComputer({ 
  onSimulate, 
  onValidate,
  isSimulating,
  code, 
}) {
  const [activeApp, setActiveApp] = useState("mail");
  const [mailRead, setMailRead] = useState(false);

  // ✅ FIX : Fonction pour ouvrir le simulateur depuis le mail
  const handleOpenSimulator = () => {
    setMailRead(true);
    setActiveApp("simulator");
  };

  return (
    <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 min-h-[80vh] p-6">
      <div className="max-w-6xl mx-auto">
        {/* OS Header */}
        <div className="bg-slate-900/60 border border-slate-700 rounded-t-xl p-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-red-500" />
              <div className="w-3 h-3 rounded-full bg-amber-500" />
              <div className="w-3 h-3 rounded-full bg-emerald-500" />
            </div>
            <span className="text-xs font-mono text-slate-400">
              EXECUTIVE_TERMINAL v2.4.1
            </span>
          </div>
          
          <div className="text-xs text-slate-500">
            USER: EXECUTIVE_006 • {new Date().toLocaleTimeString()}
          </div>
        </div>

        {/* Taskbar */}
        <div className="bg-slate-900/80 border-x border-slate-700 p-2 flex gap-2">
          <button
            onClick={() => setActiveApp("mail")}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition
              ${activeApp === "mail"
                ? "bg-indigo-600 text-white"
                : "bg-slate-800 text-slate-300 hover:bg-slate-700"
              }
            `}
          >
            <span className="text-lg">📧</span>
            <span>Mail</span>
            {!mailRead && (
              <span className="px-1.5 py-0.5 rounded-full bg-red-500 text-white text-xs">
                1
              </span>
            )}
          </button>

          <button
            onClick={() => {
              setActiveApp("simulator");
              setMailRead(true);
            }}
            disabled={!mailRead}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition
              ${activeApp === "simulator"
                ? "bg-purple-600 text-white"
                : mailRead
                  ? "bg-slate-800 text-slate-300 hover:bg-slate-700"
                  : "bg-slate-800/50 text-slate-600 cursor-not-allowed"
              }
            `}
          >
            <span className="text-lg">⚙️</span>
            <span>Policy Simulator</span>
          </button>
        </div>

        {/* App Window */}
        <div className="bg-black/40 border-x border-b border-slate-700 rounded-b-xl min-h-[600px]">
          {activeApp === "mail" && (
            <ExecutiveMail 
              onRead={() => setMailRead(true)}
              onOpenSimulator={handleOpenSimulator} // ✅ Passer le callback
            />
          )}

          {activeApp === "simulator" && (
            <PolicyBuilder
              onSimulate={onSimulate}
              onValidate={onValidate}
              isSimulating={isSimulating}
              code={code}
            />
          )}
        </div>
      </div>
    </div>
  );
}